module.exports = __webpack_public_path__ + "static/media/avg-revenue-per-trip.7b3445a3.png";